import axios from "axios";
let Base_Url = process.env.REACT_APP_BASE_URL;
export const register = async (userData) => {
  return await axios.post(`${Base_Url}/api/auth/register`, userData);
};

export const login = async (userData) => {
  return await axios.post(`${Base_Url}/api/auth/login`, userData);
};

export const resetPassword = async (userData) => {
  console.log(userData)
  return await axios.post(`${Base_Url}/api/auth/verifyResetPasswordEmail`, userData);
};

export const resetPassword2 = async (userData) => {
  console.log(userData)
  return await axios.post(`${Base_Url}/api/auth/resetVerifiedPassword`, userData);
};

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("token", token);
  } else {
    delete axios.defaults.headers.common["Authorization"];
    localStorage.removeItem("token");
    localStorage.removeItem("role");
  }
};

export const clearAuthToken = () => {
  delete axios.defaults.headers.common["Authorization"];
  localStorage.removeItem("token");
  localStorage.removeItem("role");
};

export const getAuthToken = () => localStorage.getItem("token");

export async function fetchUserDetails(
  setUserDetails,
  navigate,
  setProfilePhoto,
  countries
) {
  try {
    const token = getAuthToken();
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const res = await axios.get(`${Base_Url}/api/user`);
      const selectedCountry = countries.find(
        (country) => country.value === res.data.user.country
      );
      setUserDetails({
        id: res.data.user._id || "",
        firstName: res.data.user.firstName || "",
        lastName: res.data.user.lastName || "",
        email: res.data.user.email || "",
        password: res.data.user.password || "",
        country: selectedCountry || "",
        bankDetails: {
          accountNumber: res.data.user.bankDetails?.accountNumber || "",
          ifscCode: res.data.user.bankDetails?.ifscCode || "",
          swiftCode: res.data.user.bankDetails?.swiftCode || "",
          accountHolderName: res.data.user.bankDetails?.accountHolderName || "",
          bankName: res.data.user.bankDetails?.bankName || "",
          bankAddress: res.data.user.bankDetails?.bankAddress || "",
          transitCode: res.data.user.bankDetails?.transitCode || "",
          institutionNumber: res.data.user.bankDetails?.institutionNumber || "",
        },
        eTranferEmail: res.data.user.eTranferEmail || "",
        paypalEmail: res.data.user.paypalEmail || "",
      });
      // console.log(res.data.user, ">res.data.user")
      setProfilePhoto(res.data.user?.profilePhoto);
    }
  } catch (err) {
    console.error(err.response?.status);
    if (err.response?.status === 401 || err.response?.status === 404) {
      await clearAuthToken();
      navigate("/login");
      window.location.reload();
    }
    setUserDetails({});
  }
}

export async function fetchSingleUserDetails(
  user,
  setUserDetails,
  setProfilePhoto
) {
  try {
    setUserDetails({
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      email: user.email || "",
      password: user.password || "",
      country: user.country || "",
      bankDetails: {
        accountNumber: user.bankDetails?.accountNumber || "",
        ifscCode: user.bankDetails?.ifscCode || "",
        swiftCode: user.bankDetails?.swiftCode || "",
        accountHolderName: user.bankDetails?.accountHolderName || "",
        bankName: user.bankDetails?.bankName || "",
        bankAddress: user.bankDetails?.bankAddress || "",
        transitCode: user.bankDetails?.transitCode || "",
        institutionNumber: user.bankDetails?.institutionNumber || ""
      },
      eTranferEmail: user.eTranferEmail || "",
      paypalEmail: user.paypalEmail || "",
    });
    setProfilePhoto(user?.profilePhoto);
  } catch (err) {
    console.error(err);
    setUserDetails({});
  }
}
